export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      pageTitle: 'Page Not Found',
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
      action: 'read',
      errorPage: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      pageTitle: 'Login',
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/root/login',
    name: 'auth-root-login',
    component: () => import('@/views/pages/authentication/LoginRoot.vue'),
    meta: {
      pageTitle: 'Login',
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/app/:url/login',
    name: 'auth-login-application',
    component: () => import('@/views/pages/authentication/LoginApplication.vue'),
    meta: {
      pageTitle: 'Login Application',
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      pageTitle: 'Register',
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      service: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
]
